var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popup',{ref:"innerPopup",class:['step-' + _vm.step],attrs:{"priority":100,"size":"small dark"},scopedSlots:_vm._u([{key:"default",fn:function(popup){return [_vm._t("default",null,{"step":_vm.step,"advanceStep":_vm.advanceStep,"acceptUrl":_vm.acceptUrl},popup)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }